// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"26":"ea2463ad317b233b","70":"3240183691a6b93f","83":"319597b2e9042909"}[chunkId] + ".js";
};